import { createSelector } from "reselect";

export const outcomesTabEnabledSelector = createSelector(() => false);
